import { Menu, X } from "lucide-react";
import { handleScrollTo, NAV_LINKS, THEME } from "../App";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CONTACT_INFO = {
  address: "16/4, Mathura Road, Faridabad-121002, Haryana, India",
  email: "custcare@fokallamps.com",
  phone: "+91 81303 29152",
};

export const MobileHeader = ({ isOpen, setIsOpen }) => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      height: "64px",
      backgroundColor: THEME.colors.bg,
      borderBottom: `1px solid ${THEME.colors.border}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 24px",
      zIndex: 50,
      boxSizing: "border-box",
    }}
  >
    {/* Logo Area */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <img
        src="/logo.png" // 🔁 replace with your actual logo path
        alt="FOKAL Logo"
        style={{
          height: "38px", // slightly smaller than the main header
          width: "auto",
          objectFit: "contain",
          display: "block",
        }}
      />
    </div>

    <button
      onClick={() => setIsOpen(!isOpen)}
      style={{
        padding: "8px",
        color: "white",
        backgroundColor: THEME.colors.primary,
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isOpen ? <X size={24} /> : <Menu size={24} />}
    </button>
  </div>
);

export const MobileDrawer = ({ isOpen, setIsOpen }) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        initial={{ x: "100%" }}
        animate={{ x: 0 }}
        exit={{ x: "100%" }}
        transition={{ type: "tween", duration: 0.3 }}
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: THEME.colors.bgDrawer,
          zIndex: 40,
          paddingTop: "80px",
          paddingLeft: "24px",
          paddingRight: "24px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          boxSizing: "border-box",
        }}
      >
        <nav style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {NAV_LINKS.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={() => setIsOpen(!isOpen)}
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "white",
                textDecoration: "none",
                textTransform: "uppercase",
                fontFamily: THEME.fonts.body,
              }}
            >
              {link.name}
            </a>
          ))}
        </nav>

        <div
          style={{
            height: "1px",
            backgroundColor: THEME.colors.border,
            margin: "8px 0",
          }}
        ></div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            color: THEME.colors.textMuted,
          }}
        >
          {/* <div>
            <h3
              style={{
                color: "white",
                fontWeight: 600,
                marginBottom: "4px",
                textTransform: "uppercase",
                fontSize: "14px",
              }}
            >
              Headquarters
            </h3>
            <p style={{ margin: 0, fontSize: "14px" }}>
              {CONTACT_INFO.address}
            </p>
          </div> */}
          <div>
            <h3
              style={{
                color: "white",
                fontWeight: 600,
                marginBottom: "4px",
                textTransform: "uppercase",
                fontSize: "14px",
              }}
            >
              Contact
            </h3>
            <p style={{ margin: 0, fontSize: "14px" }}>{CONTACT_INFO.email}</p>
          </div>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);

export const TopNav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [hoveredLink, setHoveredLink] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "80px",
        padding: "0 48px",
        borderBottom: scrolled
          ? "1px solid rgba(255,255,255,0.05)"
          : "1px solid rgba(255,255,255,0.1)",
        position: "fixed", // Changed from absolute to fixed
        top: 0,
        right: 0,
        left: "0px",
        zIndex: 40,
        backgroundColor: scrolled ? "rgba(9, 9, 11, 0.9)" : "transparent", // Dark background on scroll
        backdropFilter: "blur(10px)",
        transition: "all 0.3s ease",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <img
          src="/logo.png" // 🔁 replace with your logo path
          alt="FOKAL Logo"
          style={{
            height: "40px", // controls logo size
            width: "auto",
            objectFit: "contain",
            display: "block",
          }}
        />
      </div>
      <div style={{ display: "flex", gap: "32px" }}>
        {NAV_LINKS.map((link) => (
          <a
            key={link.name}
            href={link.href}
            onClick={(e) => handleScrollTo(e, link.href)}
            onMouseEnter={() => setHoveredLink(link.name)}
            onMouseLeave={() => setHoveredLink(null)}
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              color: hoveredLink === link.name ? THEME.colors.accent : "white", // Gold on hover
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              position: "relative",
              transition: "color 0.3s ease",
            }}
          >
            {link.name}
          </a>
        ))}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
        {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "white",
            cursor: "pointer",
            textTransform: "uppercase",
            fontWeight: "bold",
            fontSize: "14px",
            letterSpacing: "0.05em",
          }}
        >
          Get In Touch
          <ArrowRight size={16} style={{ marginLeft: "8px" }} />
        </div> */}
        <div
          style={{
            width: "1px",
            height: "24px",
            backgroundColor: "rgba(255,255,255,0.2)",
          }}
        ></div>
        <Link
          to={"/rfq"}
          style={{
            backgroundColor: "#cc0000", // FOKAL red
            color: "white",
            border: "none",
            padding: "12px 24px",
            fontSize: "13px",
            fontWeight: 800,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            transition: "all 0.25s ease",
            boxShadow: "0 6px 18px rgba(204,0,0,0.25)",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#000";
            e.currentTarget.style.boxShadow = "0 8px 22px rgba(0,0,0,0.35)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#cc0000";
            e.currentTarget.style.boxShadow = "0 6px 18px rgba(204,0,0,0.25)";
          }}
        >
          Get a Quote
        </Link>
      </div>
    </nav>
  );
};
